var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-container',[_c('el-header',{staticClass:"el-header"},[_c('home-header')],1),_c('el-container',[_c('el-aside',{attrs:{"width":"355px"}},[_c('left-menu')],1),_c('el-main',[_c('router-view')],1)],1)],1),_c('bottomView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }